import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';

export const findParentPathById = (tree: IPublishRulesTreeItem[], targetId: string): IPublishRulesTreeItem[] => {
  const stack = tree.map(node => ({ node, path: [] as IPublishRulesTreeItem[] }));

  while (stack.length > 0) {
    const { node, path } = stack.pop()!;

    if (node.id === targetId) {
      return path;
    }

    if (Array.isArray(node.children)) {
      stack.push(
        ...node.children.map(child => ({
          node: child,
          path: [...path, node],
        })),
      );
    }
  }

  return [];
};
